import { type AsyncBelongsTo, attr, belongsTo } from '@ember-data/model';
import { apiAction } from '@mainmatter/ember-api-actions';
import AbstractSummaryPageModel from 'garaje/models/abstract/abstract-summary-page';
import adapter from 'garaje/utils/decorators/adapter';
import { type SingleResponse } from 'jsonapi/response';

import type GlobalFlowModel from './global-flow';

@adapter('summary-page')
class GlobalSummaryPageModel extends AbstractSummaryPageModel {
  @belongsTo('global-flow', { async: true, inverse: 'summaryPage' }) declare flow: AsyncBelongsTo<GlobalFlowModel>;
  @attr('string') declare message?: string | null;
  @attr('string') declare image?: string | null;

  async deleteSummaryPhoto(): Promise<{ data: Record<string, unknown> }> {
    const response = await apiAction<SingleResponse<GlobalSummaryPageModel>>(this, {
      method: 'DELETE',
      path: 'attachments/image',
    });
    if (response) {
      response.data.type = 'global-summary-pages';
    }

    return response;
  }
}

export default GlobalSummaryPageModel;

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'global-summary-page': GlobalSummaryPageModel;
  }
}
